import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";
import { routes } from "./BusinessInsightsRoutes";

const BusinessInsightsApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "BusinessInsights" */ "./BusinessInsightsApp");
    return { default: namedExport.BusinessInsightsApp };
});

export const BusinessInsights: TeamAppConfig = {
    title: "Business Insights",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Metrics and insights for several areas inside Substrate.",
    team: "BusinessInsights",
    publicId: "FOUNDATIONBUSINESSINSIGHTS\\Triage",
    owner: "FoundationBIEng@microsoft.com",
    role: "*",
    tags: ["Foundation", "Business", "Insights", "Teams", "Calls", "Meetings", "Messages", "Emails", "Smart", "Reply"],
    app: BusinessInsightsApp,
    path: routes.BasePath
};
